export const ReminderIndexSceneTranslation = {
  fi: {
    ReminderIndexScene: {
      title: 'Muistutukset',
    },
  },
};
